import { Box, Text } from '@nimbus-ds/components';
import { InteractiveList } from '@nimbus-ds/patterns';
import { CurrencyType } from '@tiendanube/common';
import { useResponsive } from 'commons/components';
import { HiddenVariantTag } from 'domains/Catalog/Categories/components';
import { VariantStockPrice } from 'domains/Orders/components/ProductSearcher/ProductList/VariantStockPrice';
import {
  ProductInterface,
  SelectedProductInterface,
} from 'domains/Orders/components/ProductSearcher/types';

interface VariantListItemProps<Minimalistic extends boolean> {
  name: string;
  variant: ProductInterface<false>;
  selectedVariant?: SelectedProductInterface;
  minimalistic?: boolean;
  selectedVariantsLimitReached?: boolean;
  currencyDisplay?: CurrencyType;
  showPrice: boolean;
  allowInfiniteStockSelection: boolean;
  onChange: (
    variants: ProductInterface<Minimalistic>[],
    checked: boolean,
  ) => void;
}

function VariantListItem<Minimalistic extends boolean>({
  name,
  variant,
  selectedVariant,
  minimalistic,
  selectedVariantsLimitReached = false,
  showPrice,
  onChange,
  currencyDisplay,
  allowInfiniteStockSelection,
}: Readonly<VariantListItemProps<Minimalistic>>) {
  const isDisabled =
    (!minimalistic &&
      ((variant as ProductInterface<false>).stock === 0 ||
        ((variant as ProductInterface<false>).stock === null &&
          !allowInfiniteStockSelection) ||
        selectedVariant?.isPreselected)) ||
    (selectedVariantsLimitReached && !selectedVariant);
  const { isMobile } = useResponsive();

  return (
    <InteractiveList.CheckboxItem
      topDivider={false}
      key={variant.variantId}
      title={name}
      showTitle={false}
      checkbox={{
        name: 'checkbox-element',
        disabled: isDisabled,
        checked: !!selectedVariant,
        onChange: ({ currentTarget }) =>
          onChange([variant], currentTarget.checked),
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box flex={showPrice ? '1' : '2'} alignSelf="center" paddingRight="2">
          <Box display="flex" flexDirection="row" gap="2">
            <Text
              color={isDisabled ? 'neutral-textDisabled' : 'neutral-textHigh'}
            >
              {name}
            </Text>
            <HiddenVariantTag visible={variant.variantVisible} />
          </Box>
        </Box>
        {!minimalistic && (
          <Box flex={isMobile ? '2' : '1'}>
            <VariantStockPrice
              showPrice={showPrice}
              variant={variant}
              currencyDisplay={currencyDisplay}
            />
          </Box>
        )}
      </Box>
    </InteractiveList.CheckboxItem>
  );
}

export default VariantListItem;
